export const DATE_TIME_FORMAT_FULL = 'dd-MM-yyyy - HH:mm:ss';
